export const CORRELATION_ID_LABEL = 'x-correlation-id' as const
export const AUTH_LABEL = 'Authorization' as const
